import CryptoJS from "crypto-js";
import Logger from "./logger";

export default {
  redirectTwitter,
  setTwitterText,
  setTwitterCapture,
  setTwitterCaptureCross,
  setTwitterCaptureGraph,
  setTwitterRequest,
  setTwitterAccess,
  getTwitterText,
  getTwitterCapture,
  getTwitterCaptureCross,
  getTwitterCaptureGraph,
  getTwitterRequest,
  getTwitterAccess,
  aesEncrypt,
  aesDecrypt,
  resetTwitterStorage,
};

/** 暗号化key&iv */
const aesKey = CryptoJS.enc.Utf8.parse("secrettoencrypts");
const aesIv = CryptoJS.enc.Utf8.parse("1234567890abcdef");

/**
 * Twitter認証画面へ遷移
 * @param {*} redirectUrl 認証画面URL
 * @param {*} oauthToken リクエストトークン
 */
function redirectTwitter(redirectUrl, oauthToken) {
  Logger.debug("[sns]lib - redirectTwitter()");
  let subWin = window.open("", "APPROVAL");
  let url = redirectUrl + oauthToken;
  subWin.location.href = url;
}

/**
 * Twitter投稿テキストを登録
 * @param {*} twitterText 投稿テキスト
 */
function setTwitterText(twitterText) {
  Logger.debug("[sns]lib - setTwitterText(" + twitterText + ")");
  if (window.localStorage) {
    if (typeof twitterText !== "undefined") {
      window.localStorage.setItem("twitterText", twitterText);
    }
  }
}

/**
 * Twitter投稿画像を登録
 * @param {*} twitterCapture 投稿画像
 */
function setTwitterCapture(twitterCapture) {
  Logger.debug("[sns]lib - setTwitterCapture(" + twitterCapture + ")");
  if (window.localStorage) {
    if (typeof twitterCapture !== "undefined") {
      window.localStorage.setItem(
        "twitterCapture",
        JSON.stringify(twitterCapture)
      );
    }
  }
}

/**
 * Twitter投稿画像を登録
 * @param {*} twitterCapture 投稿画像
 */
function setTwitterCaptureCross(twitterCaptureCross) {
  Logger.debug(
    "[sns]lib - setTwitterCaptureCross(" + twitterCaptureCross + ")"
  );
  if (window.localStorage) {
    if (typeof twitterCaptureCross !== "undefined") {
      window.localStorage.setItem(
        "twitterCaptureCross",
        JSON.stringify(twitterCaptureCross)
      );
    }
  }
}

/**
 * Twitter投稿画像を登録
 * @param {*} twitterCapture 投稿画像
 */
function setTwitterCaptureGraph(twitterCaptureGraph) {
  Logger.debug(
    "[sns]lib - setTwitterCaptureGraph(" + twitterCaptureGraph + ")"
  );
  if (window.localStorage) {
    if (typeof twitterCaptureGraph !== "undefined") {
      window.localStorage.setItem(
        "twitterCaptureGraph",
        JSON.stringify(twitterCaptureGraph)
      );
    }
  }
}

/**
 * リクエストトークンをlocal storageに保存
 * @param {*} twitterRequest リクエストトークン
 */
function setTwitterRequest(twitterRequest) {
  Logger.debug("[sns]lib - setTwitterRequest(" + twitterRequest + ")");
  if (window.localStorage) {
    if (typeof twitterRequest !== "undefined") {
      window.localStorage.setItem(
        "twitterRequest",
        JSON.stringify(twitterRequest)
      );
    }
  }
}

/**
 * アクセストークンをlocal storageに保存
 * @param {*} twitterAccess アクセストークン
 */
function setTwitterAccess(twitterAccess) {
  Logger.debug("[sns]lib - setTwitterAccess(" + twitterAccess + ")");
  if (window.localStorage) {
    if (typeof twitterAccess !== "undefined") {
      window.localStorage.setItem(
        "twitterAccess",
        JSON.stringify(twitterAccess)
      );
    }
  }
}

/**
 * Twitter投稿テキストを返却
 */
function getTwitterText() {
  Logger.debug("[sns]lib - getTwitterText()");
  if (window.localStorage) {
    const storage = localStorage;
    return storage.getItem("twitterText");
  }
}

/**
 * Twitter投稿画像を返却
 */
function getTwitterCapture() {
  Logger.debug("[sns]lib - getTwitterCapture()");
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("twitterCapture"));
  }
}

/**
 * Twitter投稿画像を返却
 */
function getTwitterCaptureCross() {
  Logger.debug("[sns]lib - getTwitterCaptureCross()");
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("twitterCaptureCross"));
  }
}

/**
 * Twitter投稿画像を返却
 */
function getTwitterCaptureGraph() {
  Logger.debug("[sns]lib - getTwitterCaptureGraph()");
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("twitterCaptureGraph"));
  }
}

/**
 * Twitter投稿画像を返却
 */
function getTwitterRequest() {
  Logger.debug("[sns]lib - getTwitterRequest()");
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("twitterRequest"));
  }
}

/**
 * Twitter投稿画像を返却
 */
function getTwitterAccess() {
  Logger.debug("[sns]lib - getTwitterAccess()");
  if (window.localStorage) {
    const storage = localStorage;
    return JSON.parse(storage.getItem("twitterAccess"));
  }
}

/**
 * AES暗号化
 * @param {*} word 暗号化をする文字列
 */
function aesEncrypt(word) {
  Logger.debug("[sns]lib - aesEncrypt()");
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, aesKey, {
    iv: aesIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString().toUpperCase();
}

/**
 * AES復号化
 * @param {*} word 復号化をする文字列
 */
function aesDecrypt(word) {
  Logger.debug("[sns]lib - aesDecrypt()");
  var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  var decrypt = CryptoJS.AES.decrypt(srcs, aesKey, {
    iv: aesIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

function resetTwitterStorage() {
  if (window.localStorage) {
    const storage = localStorage;
    storage.removeItem("twitterText");
    storage.removeItem("twitterCapture");
    storage.removeItem("twitterCaptureCross");
    storage.removeItem("twitterCaptureGraph");
    storage.removeItem("twitterRequest");
    storage.removeItem("twitterAccess");
  }
}
